import { useSelector } from 'react-redux';
import useAlertsBackfillOnReconnect from '@rsos/reduxDataStore/src/features/alerts/useAlertsBackfillOnReconnect';
import type { AlertsBackfillStreamWS } from '@rsos/reduxDataStore/src/features/alerts/useAlertsBackfillOnReconnect';
import { getRspAlertQueueMaxSize } from '@rsos/utils/metaTags';
import type { RootState } from '../../../app';
import canViewAlerts from '../../../utils/canViewAlerts';

/**
 * Backfills alerts after a StreamWS reconnect, gated behind the same alerts
 * access check as the live alert handling.
 */
const useHandleAlertsBackfill = (): void => {
  const streamWS = window?.__RSOS?.streamWS?.instance as
    | AlertsBackfillStreamWS
    | undefined;

  const hasAlertsAccess = useSelector((state: RootState) =>
    canViewAlerts(state.sinatra, state.psaps),
  );
  const orgName = useSelector(
    (state: RootState) => state.sinatra?.user?.currentOrg?.name,
  );
  const currentApplication = useSelector(
    (state: RootState) => state.sinatra?.user?.currentRole?.application,
  );

  useAlertsBackfillOnReconnect({
    streamWS,
    enabled: Boolean(hasAlertsAccess && orgName),
    orgName,
    queueMaxSize: getRspAlertQueueMaxSize(),
    currentApplication,
  });
};

export default useHandleAlertsBackfill;
